var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#67AD44","fillRule":"evenodd","d":"M35.0180358,904.665954 C34.7478767,904.395795 34.3103664,904.395795 34.0402072,904.665954 L31.2090686,907.497093 L25.418627,913.287534 L21.1804479,909.049355 C20.9102888,908.779196 20.4727785,908.779196 20.2026194,909.049355 C19.9324602,909.319514 19.9324602,909.757486 20.2026194,910.027184 L24.9294822,914.754046 C25.0645618,914.889126 25.2415944,914.956896 25.418627,914.956896 C25.5956596,914.956896 25.7722312,914.889126 25.9073108,914.754046 L32.1868971,908.474921 L35.0180358,905.643782 C35.2881949,905.374084 35.2881949,904.935652 35.0180358,904.665954","transform":"translate(-20 -904.463)"}));
}

Check.defaultProps = {"width":"16","height":"11","viewBox":"0 0 16 11"};

module.exports = Check;

Check.default = Check;
